<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qAgQqH/tc-custom/9781504065665.jpg?1701350720859" alt="This image is the cover for the book Iron Spiders, The Miles Standish Rice Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Iron Spiders, The Miles Standish Rice Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A bizarre death on an isolated Florida island requires a unique detective in this Golden Age mystery by the author of the Duncan Maclain series.</b></p><p>Young electrical engineer Donald Buchanan is excited to be working again—and to spend his winter in Florida instead of New York. Instead of waiting tables, he’ll be running a small power plant on Broken Heart Key, a private island owned by eccentric billionaire Aaron Tuckerton. Never mind his boss’s strange warning about people wanting him dead . . .</p><p>But trouble quickly follows Don to paradise when a servant mysteriously jumps to her death in what she should’ve known were barracuda-infested waters. Then a mysterious necklace known as “the Iron Spider” is discovered in her room. Don believes there needs to be an inquest, but Aaron phones for a special investigator instead.</p><p>The next morning, Don is greeted by Miles Standish Rice. With his schoolboy attitude and voracious appetite, “Stan” may not seem like the type to bring a killer to justice. But as things take a turn for the deadlier on Broken Heart Key, it becomes clear to Don the PI is his only chance of getting off the island alive . . .</p><p><i>Baynard Kendrick was a founding member of the Mystery Writers of America, the holder of the organization’s first membership card, and a winner of its Grand Master Award.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Baynard Kendrick
      </h2>
      
      <p class="authorDescription body article">Baynard Kendrick (1894&ndash;1977) was one of the founders of the Mystery Writers of America, later named a Grand Master by the organization. After returning from military service in World War I, Kendrick wrote for pulp magazines such as <I>Black Mask</I> and <I>Dime Detective&#160;</I><I>Magazine </I>under various pseudonyms before creating the Duncan Maclain character for which he is now known. The blind detective appeared in twelve novels, several short stories, and three films.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.Com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e952165